import Styles from "./Card.module.css";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSpring, animated } from "react-spring";

export interface CardPropos {
  img?: string;
  title?: string;
  desc?: string;
  slug?: string;
  className?: string;
  shownBtn?: boolean;
  bgColor?: string;
  textColor?: string;
  showAll?: boolean;
  width?: string;
  cardVersion?: string;
  onClick?: () => void;
}

const Card: React.FC<CardPropos> = ({
  className,
  img,
  title,
  desc,
  slug,
  shownBtn = true,
  bgColor = "bg-white",
  textColor = "text-black",
  showAll = false,
  width = "w-[30rem]",
  cardVersion = "1",
  onClick,
}) => {
  const [show, setShown] = useState(false);

  const props3 = useSpring({
    transform: show ? "scale(1.03)" : "scale(1)",
    boxShadow: show
      ? "0 20px 25px rgb(0 0 0 / 30%)"
      : "0 2px 10px rgb(0 0 0 / 8%)",
  });
  return (
    <>
      {cardVersion === "1" ? (
        <animated.div
          className={`${Styles.card} ${bgColor} rounded-lg  ${width}  `}
          style={props3}
          onMouseEnter={() => setShown(true)}
          onMouseLeave={() => setShown(false)}
          onClick={onClick}
        >
          <img src={img} alt="" className="" />
          <h2 className={`font-bold ${textColor}`}>{title}</h2>
          <div className="">
            {showAll === true ? (
              <div className={`ml-4 ${textColor}  `}>{desc}</div>
            ) : (
              <div
                className={` ${textColor} `}
                dangerouslySetInnerHTML={{
                  __html:
                    desc?.substring(0, 80).replace(/<\/?strong>/g, "") +
                    (desc && desc?.length > 80 ? "..." : ""),
                }}
              />
            )}
          </div>
          {shownBtn && (
            <div className={Styles.btnn}>
              <Link to={`/actualités/${slug}`}>
                <span className=" text-primary">Voir plus</span>
              </Link>
            </div>
          )}
        </animated.div>
      ) : (
        <animated.div
          className={`${bgColor} ${textColor} ${width} p-6 rounded-lg flex flex-col justify-between h-80`}
          style={props3}
          onMouseEnter={() => setShown(true)}
          onMouseLeave={() => setShown(false)}
          onClick={onClick}
        >
          <h2 className={`font-bold   ${textColor}`}>{title}</h2>
          <div className="flex-grow overflow-hidden">
            {showAll ? (
              <div className="overflow-hidden">{desc}</div>
            ) : (
              <div
                className="overflow-hidden"
                dangerouslySetInnerHTML={{
                  __html:
                    desc?.substring(0, 80).replace(/<\/?strong>/g, "") +
                    (desc && desc?.length > 80 ? "..." : ""),
                }}
              />
            )}
          </div>
          {shownBtn && (
            <div className="mt-auto">
              <Link to={`/actualités/${slug}`}>
                <span className="text-primary">Voir plus</span>
              </Link>
            </div>
          )}
        </animated.div>
      )}
    </>
  );
};

export default Card;
